import type { User } from "@dndbeyond/auth/types/user";
import { createContext, type Dispatch, type SetStateAction } from "react";
import type { DiceSet, Manifest } from "./types";

export const Context = createContext<{
  renderedWorker?: Worker;
  physicsWorker?: Worker;
  /** Port2 of the MessageChannel used when the rendered scene runs on the main
   *  thread (isMobileApp === true). Passed as a prop to <RenderedScene>. */
  renderedWorkerPort?: MessagePort;
  setHasPhysicsWorkerErrored?: Dispatch<SetStateAction<boolean>>;
  setIsPhysicsWorkerReady?: Dispatch<SetStateAction<boolean>>;
  nodeEnv?: string;
  env?: string;
  user?: User;
  hasPddErrored: boolean;
  isPddReady: boolean;
  userManifest?: Record<string, Manifest>;
  logger?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  errorCallback?: (message: string) => void;
  toastCallback?: (message: string) => void;
  gameId?: string;
  setHasRenderedWorkerErrored?: Dispatch<SetStateAction<boolean>>;
  setIsRenderedWorkerReady?: Dispatch<SetStateAction<boolean>>;
  diceSets?: DiceSet[];
}>({
  hasPddErrored: false,
  isPddReady: false,
});
